import { Directive, ElementRef, OnDestroy, Output, EventEmitter, AfterViewInit } from '@angular/core';
export interface ElementPosition {
    top : number;
    right : number;
    bottom : number;
    left : number;
}

export interface PositionChangeEvent {
    element : HTMLElement;
    position : ElementPosition;
}

@Directive({
    selector: '[seTimeline]',
    standalone: true
})
export class TimelineDirective implements OnDestroy, AfterViewInit {

    private observer : IntersectionObserver;
    @Output() positionChange : EventEmitter<PositionChangeEvent> = new EventEmitter();

    constructor (private el : ElementRef) {
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const rect = this.el.nativeElement.getBoundingClientRect();
                    const position : ElementPosition = {
                        top: rect.top,
                        right: rect.right,
                        bottom: rect.bottom,
                        left: rect.left
                    };
                    this.positionChange.emit({ element: this.el.nativeElement, position });
                }
            });
        });
    }

    ngAfterViewInit () : void {
        this.observer.observe(this.el.nativeElement);
    }

    ngOnDestroy () : void {
        this.observer.disconnect();
    }
}
